(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-pack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents) {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }
    function moneyShort(cents) {
      var v = cents / 100;
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(v);
    }
    function init(root) {
      if (root.dataset.packReady) return;
      root.dataset.packReady = '1';
      var items = root.querySelectorAll('[data-pack-item]');
      function refresh() {
        var total = 0, was = 0;
        items.forEach(function (it) {
          var sel = it.querySelector('[data-pack-select]');
          var o = sel && sel.options[sel.selectedIndex];
          if (!o) return;
          var p = parseInt(o.dataset.price, 10) || 0;
          var c = parseInt(o.dataset.compare, 10) || p;
          total += p; was += Math.max(c, p);
          it.querySelector('[data-pack-price]').textContent = money(p);
          var w = it.querySelector('[data-pack-was]');
          if (c > p) { w.textContent = money(c); w.hidden = false; } else { w.hidden = true; }
          var img = it.querySelector('[data-pack-img]');
          if (img && o.dataset.img && img.getAttribute('src') !== o.dataset.img) img.setAttribute('src', o.dataset.img);
          it.querySelectorAll('[data-pack-link]').forEach(function (a) { a.setAttribute('href', o.dataset.url); });
          var n = it.querySelector('[data-pack-name]');
          if (n) n.textContent = o.dataset.title;
        });
        var saving = was - total;
        root.querySelector('[data-pack-total]').textContent = money(total);
        root.querySelector('[data-pack-total-was]').textContent = money(was);
        root.querySelector('[data-pack-saving-text]').textContent = money(saving);
        root.querySelector('[data-pack-saving]').textContent = '−' + moneyShort(saving);
        root.querySelector('[data-pack-x3]').textContent = money(Math.round(total / 3));
        root.querySelector('[data-pack-x4]').textContent = money(Math.round(total / 4));
      }
      root.querySelectorAll('[data-pack-select]').forEach(function (s) { s.addEventListener('change', refresh); });
      var btn = root.querySelector('[data-pack-add]');
      var msg = root.querySelector('[data-pack-msg]');
      btn.addEventListener('click', function () {
        var list = [];
        items.forEach(function (it) {
          var sel = it.querySelector('[data-pack-select]');
          if (sel && sel.value) list.push({ id: parseInt(sel.value, 10), quantity: 1 });
        });
        if (!list.length) return;
        btn.disabled = true; msg.textContent = ((document.documentElement.lang||'fr').indexOf('fr')===0?'Ajout du pack en cours…':'Adding the pack…');
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: list })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          msg.textContent = ((document.documentElement.lang||'fr').indexOf('fr')===0?'Pack ajouté ! Direction votre panier…':'Pack added! Taking you to your cart…');
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }).catch(function () {
          btn.disabled = false;
          msg.textContent = ((document.documentElement.lang||'fr').indexOf('fr')===0?'Un article n’a pas pu être ajouté. Réessayez ou contactez-nous.':'An item could not be added. Please try again or contact us.');
        });
      });
      refresh();
    }
    function boot() { document.querySelectorAll('[data-orion-pack]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-packs-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      document.querySelectorAll('[data-orion-pt] [data-pt-add]').forEach(function (btn) {
        if (btn.dataset.ready) return;
        btn.dataset.ready = '1';
        btn.addEventListener('click', function () {
          var msg = btn.parentNode.querySelector('[data-pt-msg]');
          var items = (btn.dataset.ids || '').split(',').filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
          if (!items.length) return;
          var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
          btn.disabled = true; msg.textContent = ((document.documentElement.lang||'fr').indexOf('fr')===0?'Ajout du pack en cours…':'Adding the pack…');
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { if (!r.ok) throw new Error('add'); msg.textContent = ((document.documentElement.lang||'fr').indexOf('fr')===0?'Pack ajouté ! Direction votre panier…':'Pack added! Taking you to your cart…'); window.location.href = root + 'cart'; })
            .catch(function () { btn.disabled = false; msg.textContent = ((document.documentElement.lang||'fr').indexOf('fr')===0?'Un article n’a pas pu être ajouté. Réessayez ou contactez-nous.':'An item could not be added. Please try again or contact us.'); });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__orionStoryAnim) return;
    window.__orionStoryAnim = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
    if (window.matchMedia && window.matchMedia('(max-width: 1023px)').matches) return;

    function prepare(section) {
      if (section.classList.contains('orion-story--hero') || section.dataset.osReady) return [];
      section.dataset.osReady = '1';
      var items = [];
      var pain = section.querySelector('.orion-story__col--pain');
      var card = section.querySelector('.orion-story__card');
      if (pain && card) {
        pain.querySelectorAll('.orion-story__kicker, .orion-story__hook, .orion-story__lines li, .orion-story__after').forEach(function (el, i) {
          el.setAttribute('data-os-reveal', 'left'); el.style.setProperty('--os-i', i); items.push(el);
        });
        card.setAttribute('data-os-reveal', 'right'); card.style.setProperty('--os-i', 2); items.push(card);
      } else {
        section.querySelectorAll('.orion-story__kicker, .orion-story__hook, .orion-story__lines li, .orion-story__after, .orion-story__punch, .orion-story__intro, .orion-story__problems li, .orion-story__chips li, .orion-story__button').forEach(function (el, i) {
          el.setAttribute('data-os-reveal', 'up'); el.style.setProperty('--os-i', Math.min(i, 10)); items.push(el);
        });
      }
      return items;
    }

    function init() {
      var sections = document.querySelectorAll('.orion-story');
      if (!sections.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.01, rootMargin: '0px 0px 12% 0px' });
      var all = [];
      sections.forEach(function (s) { all = all.concat(prepare(s)); });
      document.documentElement.classList.add('os-anim');
      all.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('is-in'); } else { io.observe(el); }
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
